import { serviceProvider } from "../../../../../comun/provider/ServiceProvider";
import { VentaAnimalesResponse } from "../../../../../modulos/pesaje/ganaderia/response/VentaAnimalesResponse";
import { BaseFullScreenModalRender } from "../../../../base/modal/BaseFullScreenModalRender";
import { IConnectRender } from "../../../../definitions/IConnectRender";
import { VentaDetailRender } from "../detail/VentaDetailRender";

/** Modal a pantalla completa (solo lectura) con el detalle de una venta. */
export class VentaDetailModalRender extends BaseFullScreenModalRender {
  protected readonly elementId = "ventaDetailModal";

  constructor(private readonly _venta: VentaAnimalesResponse) {
    super();
  }

  protected get title(): string {
    return `Venta ${this._venta.codigo ?? ""}`;
  }

  protected get subtitle(): string | undefined {
    return serviceProvider.getFincaSelectedService().getRequired().nombreFinca;
  }

  protected getContent(): IConnectRender {
    return new VentaDetailRender(this._venta);
  }
}
